import React from 'react';
import PropTypes from 'prop-types'; // eslint-disable-line import/no-extraneous-dependencies
import InputTitle from './InputTitle';
import ErrorMessage from './ErrorMessage';

const InputArea = ({
  labelTitle,
  placeholder,
  onChange,
  type,
  value,
  className,
  required,
  name,
  disabled,
  pattern,
  minlength,
  maxlength,
  inputMode,
  title,
  hint,
  error,
}) => {
  const handleOnChange = (e) => onChange(e.target);
  const hintId = hint ? `${name}-hint` : undefined;
  return (
    <>
      <label>
        <InputTitle>{labelTitle}</InputTitle>
        {hint ? (
          <span className="input-hint" id={hintId}>
            {hint}
          </span>
        ) : null}
        <input
          disabled={disabled}
          type={type}
          placeholder={placeholder}
          name={name}
          className={`${className}${error ? ' has-error' : ''}`}
          onChange={handleOnChange}
          value={value}
          required={required}
          pattern={pattern}
          minLength={minlength}
          maxLength={maxlength}
          inputMode={inputMode}
          title={title}
          aria-describedby={hintId}
          aria-invalid={error ? 'true' : undefined}
        />
      </label>
      <ErrorMessage error={error} />
    </>
  );
};

InputArea.propTypes = {
  disabled: PropTypes.bool,
  labelTitle: PropTypes.string,
  placeholder: PropTypes.string,
  minlength: PropTypes.string,
  maxlength: PropTypes.string,
  inputMode: PropTypes.string,
  title: PropTypes.string,
  hint: PropTypes.string,
  error: PropTypes.string,
  onChange: PropTypes.func,
  pattern: PropTypes.string,
  type: PropTypes.string,
  value: PropTypes.string,
  className: PropTypes.string,
  name: PropTypes.string,
  required: PropTypes.bool,
};

InputArea.defaultProps = {
  disabled: false,
  labelTitle: '',
  placeholder: '',
  minlength: '0',
  maxlength: undefined,
  inputMode: undefined,
  title: undefined,
  hint: '',
  error: '',
  onChange: () => { },
  pattern: null,
  type: 'text',
  value: '',
  className: 'textInput',
  name: '',
  required: false,
};
export default InputArea;
